module.exports = __webpack_public_path__ + "img/home-icon-active.e848cd49.svg";